import Layout from "./../Layout";
import { Bed, Clock, XCircle, Info } from "lucide-react";

export default function RoomPolicy() {
  return (
    <Layout pageTitle="Room Policy">
      <div className="space-y-8">
        
        <section className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-700 flex items-center gap-2">
            <Clock className="w-5 h-5 text-blue-600" /> Check-In & Check-Out
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li><strong>Check-In:</strong> From 2:00 PM onwards</li>
            <li><strong>Check-Out:</strong> By 11:00 AM</li>
            <li>Early check-in or late check-out may be available upon request, subject to availability and additional charges.</li>
            <li>Please present a valid ID and booking confirmation at check-in.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-700 flex items-center gap-2">
            <XCircle className="w-5 h-5 text-red-600" /> Cancellation Policy
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>Free cancellation up to 7 days before arrival.</li>
            <li>Cancellations within 7 days of arrival incur a 50% charge of the total booking amount.</li>
            <li>No-shows or cancellations within 24 hours of arrival are non-refundable.</li>
            <li>To cancel, contact us at <a href="mailto:info@woodchaletsella.com.lk" className="text-blue-600 hover:underline">info@woodchaletsella.com.lk</a> or call 077-1416733.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-700 flex items-center gap-2">
            <Bed className="w-5 h-5 text-green-600" /> Room Amenities
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>Complimentary Wi-Fi in all rooms.</li>
            <li>Daily housekeeping included.</li>
            <li>Private bathrooms with hot water and toiletries.</li>
            <li>Air conditioning and ceiling fans in select rooms.</li>
            <li>Balconies with scenic views of Ella's landscapes.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-700 flex items-center gap-2">
            <Info className="w-5 h-5 text-indigo-600" /> House Rules
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>No smoking inside the rooms; designated smoking areas are available.</li>
            <li>Pets are not allowed on the premises.</li>
            <li>Guests are responsible for any damage to property during their stay.</li>
            <li>Quiet hours are observed from 10:00 PM to 7:00 AM.</li>
            <li>Outside food and beverages are not permitted in the restaurant area.</li>
          </ul>
        </section>

        <p className="text-sm text-gray-500 italic">
          For any questions or special requests, please contact us at{" "}
          <a href="mailto:info@woodchaletsella.com.lk" className="text-blue-600 hover:underline">
            info@woodchaletsella.com.lk
          </a>{" "}
          or 077-1416733.
        </p>
      </div>
    </Layout>
  );
}